<template>
  <div
    data-cy="page-add-fieldworks"
    aria-labelledby="fieldworks add page"
    ref="fieldworksAddPage"
  >
    <div class="">
      <div class="header-text pb-3" data-cy="header-fieldworks-add">
        Fieldwork Categories
      </div>
      <div class="subhead-text pb-5">
        Please select the type of fieldwork for your entry.
      </div>
    </div>
    <div class="grid lg:grid-cols-4 lg:grid-rows-1 gap-6">
      <div class="lg:col-span-3 lg:row-span-2">
        <div class="box-style">
          <div class="pb-5">
            <div class="secondhead-text pb-2">Activities with Your Mentor</div>
            <div class="w-full">
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/experience')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    id="icon-experiences-experience"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="compass-experience"
                      d="M9.821,11.44,5.747,13.3a.9.9,0,0,0-.445.445L3.44,17.821a.558.558,0,0,0,.74.74L8.253,16.7a.9.9,0,0,0,.445-.445l1.862-4.074a.558.558,0,0,0-.74-.74Zm-2.184,4.2a.9.9,0,1,1,0-1.275A.9.9,0,0,1,7.637,15.637ZM7,8a7,7,0,1,0,7,7A7,7,0,0,0,7,8ZM7,20.645A5.645,5.645,0,1,1,12.645,15,5.652,5.652,0,0,1,7,20.645Z"
                      transform="translate(0 -8)"
                    />
                  </svg>
                  <div class="font-bold">Experience</div>
                </div>
              </div>
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/debrief')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="user-circle"
                      d="M7,10.71a2.71,2.71,0,1,0,2.71,2.71A2.71,2.71,0,0,0,7,10.71Zm0,4.065a1.355,1.355,0,1,1,1.355-1.355A1.355,1.355,0,0,1,7,14.774ZM7,8a7,7,0,1,0,7,7A7,7,0,0,0,7,8ZM7,20.645a5.613,5.613,0,0,1-3.672-1.366,2.432,2.432,0,0,1,1.965-1.115A5.743,5.743,0,0,0,7,18.435a5.653,5.653,0,0,0,1.708-.271,2.439,2.439,0,0,1,1.965,1.115A5.613,5.613,0,0,1,7,20.645Zm4.592-2.374a3.744,3.744,0,0,0-2.967-1.465A8.47,8.47,0,0,1,7,17.077a8.516,8.516,0,0,1-1.626-.271,3.752,3.752,0,0,0-2.967,1.465A5.642,5.642,0,1,1,12.645,15,5.6,5.6,0,0,1,11.592,18.271Z"
                      transform="translate(0 -8)"
                    />
                  </svg>
                  <div class="font-bold">Debrief</div>
                </div>
              </div>
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/point_of_contact')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 10.888"
                  >
                    <path
                      id="comments"
                      d="M12.922,40.608a3.346,3.346,0,0,0,1.069-2.387c0-1.944-1.859-3.551-4.282-3.837A5.253,5.253,0,0,0,5.048,32C2.256,32-.007,33.74-.007,35.888a3.355,3.355,0,0,0,1.069,2.387,6.363,6.363,0,0,1-.916,1.334.562.562,0,0,0,.408.948A5.586,5.586,0,0,0,3.6,39.614a6.926,6.926,0,0,0,.69.119A5.237,5.237,0,0,0,8.937,42.11a6.433,6.433,0,0,0,1.453-.165,5.6,5.6,0,0,0,3.043.943.562.562,0,0,0,.408-.948A6.194,6.194,0,0,1,12.922,40.608ZM3.376,38.365l-.416.27a4.945,4.945,0,0,1-1.047.52c.066-.114.131-.236.194-.36l.377-.756-.6-.6a2.228,2.228,0,0,1-.722-1.555c0-1.475,1.781-2.722,3.888-2.722s3.888,1.247,3.888,2.722S7.155,38.61,5.048,38.61a5.3,5.3,0,0,1-1.191-.136l-.481-.109ZM12.1,39.777l-.6.593.377.756c.063.124.129.245.194.36a4.945,4.945,0,0,1-1.047-.52l-.416-.27-.484.112a5.3,5.3,0,0,1-1.191.136,4.522,4.522,0,0,1-3.191-1.208c2.462-.262,4.357-1.881,4.357-3.847,0-.083-.01-.163-.017-.243,1.565.352,2.739,1.38,2.739,2.576A2.228,2.228,0,0,1,12.1,39.777Z"
                      transform="translate(0.007 -32)"
                    />
                  </svg>
                  <div class="font-bold">Point of Contact</div>
                </div>
              </div>
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/ppdp_meeting')"
              >
                <div class="p-1">
                  <font-awesome-icon icon="flag" height="14" class="text-2xl" />
                  <div class="font-bold">PPDP Meeting</div>
                </div>
              </div>
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/year_end_meeting')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    id="icon-yearendmeeting"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="clock"
                      d="M15,8a7,7,0,1,0,7,7A7,7,0,0,0,15,8Zm0,12.645A5.645,5.645,0,1,1,20.645,15,5.644,5.644,0,0,1,15,20.645ZM16.744,17.7l-2.4-1.742a.341.341,0,0,1-.138-.274V11.048a.34.34,0,0,1,.339-.339h.9a.34.34,0,0,1,.339.339v4l1.885,1.372a.339.339,0,0,1,.073.474l-.531.731A.341.341,0,0,1,16.744,17.7Z"
                      transform="translate(-8 -8)"
                    />
                  </svg>
                  <div class="font-bold">Year-End Meeting</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-5">
            <div class="secondhead-text pb-2">
              Activities with Other Attorneys or Judges
            </div>
            <div class="w-full">
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/experience')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    id="icon-experiences"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="18"
                    viewBox="0 0 14 14"
                  >
                    <path
                      id="compass"
                      d="M9.821,11.44,5.747,13.3a.9.9,0,0,0-.445.445L3.44,17.821a.558.558,0,0,0,.74.74L8.253,16.7a.9.9,0,0,0,.445-.445l1.862-4.074a.558.558,0,0,0-.74-.74Zm-2.184,4.2a.9.9,0,1,1,0-1.275A.9.9,0,0,1,7.637,15.637ZM7,8a7,7,0,1,0,7,7A7,7,0,0,0,7,8ZM7,20.645A5.645,5.645,0,1,1,12.645,15,5.652,5.652,0,0,1,7,20.645Z"
                      transform="translate(0 -8)"
                    />
                  </svg>
                  <div class="font-bold">Experience</div>
                </div>
              </div>
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/networking')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    id="icon-network"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 11.2"
                  >
                    <path
                      id="users"
                      d="M2.4,36.8A1.6,1.6,0,1,0,.8,35.2,1.6,1.6,0,0,0,2.4,36.8Zm11.2,0A1.6,1.6,0,1,0,12,35.2,1.6,1.6,0,0,0,13.6,36.8Zm.8.8H12.8a1.6,1.6,0,0,0-1.128.465A3.657,3.657,0,0,1,13.55,40.8H15.2A.8.8,0,0,0,16,40v-.8A1.6,1.6,0,0,0,14.4,37.6ZM8,37.6a2.8,2.8,0,1,0-2.8-2.8A2.8,2.8,0,0,0,8,37.6Zm1.92.8H9.712a3.866,3.866,0,0,1-3.425,0H6.08A2.881,2.881,0,0,0,3.2,41.28V42a1.2,1.2,0,0,0,1.2,1.2h7.2A1.2,1.2,0,0,0,12.8,42v-.72A2.881,2.881,0,0,0,9.92,38.4Zm-5.593-.335A1.6,1.6,0,0,0,3.2,37.6H1.6A1.6,1.6,0,0,0,0,39.2V40a.8.8,0,0,0,.8.8H2.447A3.666,3.666,0,0,1,4.327,38.065Z"
                      transform="translate(0 -32)"
                    />
                  </svg>
                  <div class="font-bold">Networking</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pb-5">
            <div class="secondhead-text pb-2">Program Activities</div>
            <div class="w-full">
              <div
                class="category-chip group"
                @click="navigate('/fieldworks/add/orientation')"
              >
                <div class="p-1">
                  <svg
                    class="fill-dark-purple group-hover:fill-white"
                    id="icon-orientation"
                    xmlns="http://www.w3.org/2000/svg"
                    width="13.009"
                    height="18"
                    viewBox="0 0 13.009 16.579"
                  >
                    <path
                      id="Path_34"
                      data-name="Path 34"
                      d="M12.522,6.355a6.45,6.45,0,0,0-.946-3.361A6.347,6.347,0,0,0,9.106.7a6.19,6.19,0,0,0-6.6.573,6.832,6.832,0,0,0-.69.6,6.9,6.9,0,0,0-.591.7A6.311,6.311,0,0,0,.407,4.09,6.479,6.479,0,0,0,.1,7.515,9.538,9.538,0,0,0,1.23,10.523a17.244,17.244,0,0,0,1.835,2.616,22.937,22.937,0,0,0,1.717,1.836c.319.307.647.607.986.891l.047.038a.666.666,0,0,0,.443.187A.706.706,0,0,0,6.7,15.9c.194-.158.382-.327.566-.5.471-.429.925-.88,1.358-1.345a22.088,22.088,0,0,0,1.717-2.083,13.362,13.362,0,0,0,1.412-2.4,8.348,8.348,0,0,0,.756-2.883c.006-.1.009-.2.01-.293,0-.015,0-.03,0-.045M1.773,8.775c.017.04.034.081.05.121l-.05-.121m7.218,2.917.051-.067-.051.067m2.234-4.656c0-.031.008-.062.013-.092,0,.031-.009.062-.013.092m0,.032a7.713,7.713,0,0,1-.473,1.682A12.721,12.721,0,0,1,9.44,11.078q-.19.272-.391.538a22.336,22.336,0,0,1-1.737,1.99c-.341.347-.694.687-1.056,1.012L6.02,14.4c-.552-.509-1.081-1.045-1.581-1.605-.343-.384-.674-.781-.987-1.19a14.464,14.464,0,0,1-1.371-2.17c-.111-.22-.215-.445-.311-.672A7.741,7.741,0,0,1,1.3,7.08a5.844,5.844,0,0,1,0-1.431A5.828,5.828,0,0,1,1.631,4.4a5.833,5.833,0,0,1,.663-1.152,5.825,5.825,0,0,1,.9-.912A5.712,5.712,0,0,1,4.33,1.66a5.688,5.688,0,0,1,1.24-.343,5.7,5.7,0,0,1,1.386,0,5.616,5.616,0,0,1,1.231.342,5.712,5.712,0,0,1,1.136.672,5.825,5.825,0,0,1,.9.911A5.834,5.834,0,0,1,10.887,4.4a5.9,5.9,0,0,1,.337,1.251,6.679,6.679,0,0,1,.043.706,5.615,5.615,0,0,1-.047.714"
                      transform="translate(0.244 0.244)"
                    />
                    <path
                      id="Path_34_-_Outline"
                      data-name="Path 34 - Outline"
                      d="M5.981,16.079a.913.913,0,0,1-.576-.241c-.016-.012-.035-.027-.053-.043-.317-.265-.642-.56-1-.9a23.259,23.259,0,0,1-1.735-1.855A17.429,17.429,0,0,1,.761,10.385,9.661,9.661,0,0,1-.4,7.3a6.723,6.723,0,0,1,.32-3.554A6.512,6.512,0,0,1,.777,2.171a7.082,7.082,0,0,1,.612-.728A7,7,0,0,1,2.1.819,6.437,6.437,0,0,1,5.413-.47a6.019,6.019,0,0,1,.6-.03A6.5,6.5,0,0,1,8.961.223a6.634,6.634,0,0,1,2.565,2.386A6.737,6.737,0,0,1,12.51,6.1c0,.022,0,.04,0,.056,0,.105,0,.206-.01.3a8.553,8.553,0,0,1-.777,2.966,13.51,13.51,0,0,1-1.438,2.447,22.4,22.4,0,0,1-1.736,2.106c-.448.48-.91.938-1.373,1.359-.179.164-.373.339-.576.5a.951.951,0,0,1-.587.242ZM6.015-.013a5.529,5.529,0,0,0-.553.028A5.95,5.95,0,0,0,2.4,1.2a6.53,6.53,0,0,0-.666.58,6.613,6.613,0,0,0-.57.678A6.035,6.035,0,0,0,.378,3.922a6.236,6.236,0,0,0-.293,3.3,9.188,9.188,0,0,0,1.1,2.931A16.95,16.95,0,0,0,3,12.727a22.77,22.77,0,0,0,1.7,1.816c.346.334.665.621.973.88l.005,0,.035.029,0,0a.448.448,0,0,0,.28.134.464.464,0,0,0,.3-.132c.2-.159.383-.329.557-.488.454-.413.906-.861,1.345-1.332a21.907,21.907,0,0,0,1.7-2.06,13.031,13.031,0,0,0,1.387-2.359,8.079,8.079,0,0,0,.736-2.8c.006-.087.009-.181.01-.28v-.02c0-.008,0-.015,0-.023a6.243,6.243,0,0,0-.91-3.233A6.14,6.14,0,0,0,8.739.656,6.009,6.009,0,0,0,6.015-.013ZM6,14.689l-.163-.147L5.6,14.325C5.039,13.81,4.5,13.264,4,12.7c-.359-.4-.7-.808-1-1.2a14.609,14.609,0,0,1-1.4-2.208c-.092-.182-.18-.369-.263-.559h0l-.051-.124h0l0-.005,0,0A8.011,8.011,0,0,1,.8,6.861V6.854a6.1,6.1,0,0,1,0-1.49V5.357a6.086,6.086,0,0,1,.352-1.3l0-.008a6.089,6.089,0,0,1,.69-1.2l0-.006a6.075,6.075,0,0,1,.936-.95l.006,0a5.968,5.968,0,0,1,1.187-.7l.008,0A5.947,5.947,0,0,1,5.276.819h.009a5.943,5.943,0,0,1,1.445,0h.008a5.873,5.873,0,0,1,1.284.357l.008,0a5.968,5.968,0,0,1,1.184.7l.006,0a6.075,6.075,0,0,1,.937.95l0,.006a6.09,6.09,0,0,1,.693,1.2l0,.008a6.16,6.16,0,0,1,.351,1.3v.01a6.956,6.956,0,0,1,.044.732,5.832,5.832,0,0,1-.034.623h0c0,.03-.008.06-.013.089v.007h0l0,.027v.006a7.99,7.99,0,0,1-.488,1.736l0,0a12.865,12.865,0,0,1-1.333,2.372c-.134.191-.267.375-.4.546l-.007.009h0l-.018.023-.034.045h0a22.8,22.8,0,0,1-1.7,1.937c-.359.366-.718.71-1.068,1.023ZM1.739,8.417c.094.222.2.443.3.655A14.124,14.124,0,0,0,3.39,11.2c.3.385.623.781.975,1.174.49.549,1.016,1.083,1.564,1.588L6,14.033c.29-.266.586-.552.882-.853A22.191,22.191,0,0,0,8.6,11.211c.124-.164.254-.343.384-.529A12.387,12.387,0,0,0,10.266,8.4a7.506,7.506,0,0,0,.457-1.624,5.4,5.4,0,0,0,.044-.68,6.46,6.46,0,0,0-.041-.674,5.672,5.672,0,0,0-.321-1.191,5.6,5.6,0,0,0-.633-1.1,5.586,5.586,0,0,0-.856-.868,5.481,5.481,0,0,0-1.08-.639A5.385,5.385,0,0,0,6.666,1.3a5.48,5.48,0,0,0-1.318,0,5.459,5.459,0,0,0-1.178.326,5.48,5.48,0,0,0-1.083.642,5.586,5.586,0,0,0-.855.869,5.6,5.6,0,0,0-.631,1.1,5.6,5.6,0,0,0-.321,1.192,5.61,5.61,0,0,0,0,1.364A7.525,7.525,0,0,0,1.739,8.417Z"
                      transform="translate(0.5 0.5)"
                    />
                    <path
                      id="Path_35"
                      data-name="Path 35"
                      d="M129.517,126.758a2.282,2.282,0,0,0-1.075-.836,2.114,2.114,0,0,0-2.31.631,2.4,2.4,0,0,0-.385.66,2.189,2.189,0,0,0-.134.634,2.158,2.158,0,0,0,.3,1.243,2.12,2.12,0,0,0,.9.834,2.349,2.349,0,0,0,.733.205,2.074,2.074,0,0,0,.661-.038,2.184,2.184,0,0,0,1.678-2.118c0-.011,0-.022,0-.033a2.162,2.162,0,0,0-.368-1.183m-1.227,1.928a1.517,1.517,0,0,1-.2.119,1.5,1.5,0,0,1-.2.056.887.887,0,0,1-.477-.058,1.641,1.641,0,0,1-.208-.124,1.61,1.61,0,0,1-.154-.158.9.9,0,0,1-.173-.409.907.907,0,0,1,.179-.695,1.611,1.611,0,0,1,.155-.156,1.521,1.521,0,0,1,.2-.119,1.487,1.487,0,0,1,.2-.056.887.887,0,0,1,.478.058,1.642,1.642,0,0,1,.208.124,1.614,1.614,0,0,1,.154.158.9.9,0,0,1,.173.411c0,.045.006.09.006.137s0,.085-.006.128a.9.9,0,0,1-.18.428,1.615,1.615,0,0,1-.156.156"
                      transform="translate(-121.247 -121.375)"
                    />
                    <path
                      id="Path_35_-_Outline"
                      data-name="Path 35 - Outline"
                      d="M127.493,130.129a1.891,1.891,0,0,1-.231-.014,2.6,2.6,0,0,1-.805-.226,2.348,2.348,0,0,1-1.01-.93,2.434,2.434,0,0,1-.182-2.093,2.653,2.653,0,0,1,.422-.723,2.377,2.377,0,0,1,1.819-.843,2.162,2.162,0,0,1,.767.137,2.512,2.512,0,0,1,1.188.923,2.393,2.393,0,0,1,.413,1.315c0,.015,0,.029,0,.044A2.432,2.432,0,0,1,128,130.074,2.562,2.562,0,0,1,127.493,130.129Zm.012-4.341a1.879,1.879,0,0,0-1.439.661,2.159,2.159,0,0,0-.348.6,1.943,1.943,0,0,0-.118.565,1.9,1.9,0,0,0,.266,1.1,1.883,1.883,0,0,0,.8.738,2.1,2.1,0,0,0,.661.185,1.4,1.4,0,0,0,.171.01,2.083,2.083,0,0,0,.412-.045,1.936,1.936,0,0,0,1.482-1.881c0-.006,0-.012,0-.019v-.007a1.93,1.93,0,0,0-.324-1.048,2.038,2.038,0,0,0-.963-.749A1.676,1.676,0,0,0,127.5,125.788Zm-.011,3.067c-.049,0-.1,0-.147-.006h-.015l-.015,0a1.878,1.878,0,0,1-.244-.068l-.014,0-.013-.007a1.9,1.9,0,0,1-.238-.142l-.012-.008-.011-.01a1.864,1.864,0,0,1-.177-.182l-.009-.01-.008-.011a1.8,1.8,0,0,1-.136-.24l-.006-.012,0-.012a1.8,1.8,0,0,1-.064-.234l0-.014v-.014a1.941,1.941,0,0,1,0-.308v-.015l0-.014a1.938,1.938,0,0,1,.067-.246l0-.014.006-.013a1.926,1.926,0,0,1,.139-.241l.008-.012.009-.011a1.864,1.864,0,0,1,.179-.18l.01-.009.011-.008a1.772,1.772,0,0,1,.237-.138l.012-.006.013,0a1.738,1.738,0,0,1,.231-.065l.014,0h.014a1.866,1.866,0,0,1,.305,0h.015l.015,0a1.88,1.88,0,0,1,.244.068l.014,0,.013.007a1.9,1.9,0,0,1,.238.142l.012.008.011.01a1.872,1.872,0,0,1,.177.181l.009.01.008.011a1.8,1.8,0,0,1,.136.24l.006.012,0,.013a1.808,1.808,0,0,1,.064.236l0,.014v.014c0,.058.007.108.007.157s0,.093-.006.147v.014l0,.014a1.941,1.941,0,0,1-.067.249l0,.014-.006.013a1.933,1.933,0,0,1-.139.241l-.008.012-.01.011a1.865,1.865,0,0,1-.179.18l-.01.009-.011.008a1.766,1.766,0,0,1-.237.139l-.012.006-.013,0a1.744,1.744,0,0,1-.231.065l-.014,0h-.014C127.6,128.852,127.546,128.854,127.493,128.854Zm-.093-.491a1.374,1.374,0,0,0,.2,0,1.261,1.261,0,0,0,.14-.039,1.28,1.28,0,0,0,.148-.086,1.384,1.384,0,0,0,.112-.113.656.656,0,0,0,.132-.313c0-.036,0-.066,0-.094s0-.064,0-.1a.655.655,0,0,0-.126-.3,1.388,1.388,0,0,0-.111-.114,1.413,1.413,0,0,0-.151-.09,1.392,1.392,0,0,0-.152-.042,1.371,1.371,0,0,0-.2,0,1.252,1.252,0,0,0-.14.039,1.285,1.285,0,0,0-.148.086,1.377,1.377,0,0,0-.112.113.671.671,0,0,0-.131.512.65.65,0,0,0,.125.3,1.376,1.376,0,0,0,.111.114,1.409,1.409,0,0,0,.152.09A1.389,1.389,0,0,0,127.4,128.364Z"
                      transform="translate(-120.991 -121.119)"
                    />
                  </svg>
                  <div class="font-bold">Orientation</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lg:col-start-4 lg:row-start-1">
        <div class="box-style bg-light-gray">
          <div class="thirdhead-text pb-2">Make accurate entries:</div>
          <ol class="text-xl p-3 list-decimal">
            <li class="pb-1 text-dark-purple">
              <div class="inline-block">
                <span class="text-dark-gray">Pick the right category</span>
              </div>
            </li>
            <li class="pb-1 text-dark-purple">
              <div class="">
                <span class="text-dark-gray">Write detailed descriptions</span>
              </div>
            </li>
            <li class="pb-4 text-dark-purple">
              <div class="">
                <span class="text-dark-gray"
                  >Include personal reflections or observations</span
                >
              </div>
            </li>
          </ol>
          <div class="thirdhead-text pb-2">Be your own editor:</div>
          <ol class="text-xl p-3 list-decimal">
            <li class="pb-1 text-dark-purple">
              <div class="inline-block">
                <span class="text-dark-gray">Use complete sentences</span>
              </div>
            </li>
            <li class="pb-1 text-dark-purple">
              <div class="">
                <span class="text-dark-gray">
                  Carefully proofread your entries
                </span>
              </div>
            </li>
            <li class="pb-4 text-dark-purple">
              <div class="">
                <span class="text-dark-gray">
                  Be aware of minimum word requirements
                </span>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FieldworksAdd",
  mounted() {
    this.$refs.fieldworksAddPage.focus();
  },
  data: function () {
    return {
      route: "#",
    };
  },
  methods: {
    navigate: function (path) {
      this.$router.push(path);
    },
    select: function (index) {
      this.route = index;
    },
  },
};
</script>

<style scoped>
.category-chip {
  @apply inline-block border border-purple hover:bg-purple text-purple hover:text-white p-1 mr-5 my-2 rounded hover:cursor-pointer w-36 h-20;
}
</style>
